import { createTheme } from '@mui/material';

export const primaryTheme = createTheme({
  palette: {
    primary: {
      main: '#ff0100',
    },
  },
});
